<template>
  <div class="main">
    <div class="form-row-line col-4">
      <div class="form-field">
        <label for="village-select">Поселок:</label>
        <select
          id="village-select"
          v-model="newUserAgreement.VILLAGE"
          @change="getPlots"
          ref="village"
        >
          <option
            v-for="(village, key) in villages"
            :value="village.ID"
            :key="key"
          >
            {{ village.NAME }}
          </option>
        </select>
      </div>
      <div class="form-field" v-show="newUserAgreement.VILLAGE">
        <label for="plot-select">Участок:</label>
        <select id="plot-select" v-model="newUserAgreement.PLOT" ref="plot">
          <option v-for="(plot, key) in plots" :value="plot.ID" :key="key">
            {{ plot.NAME }}
          </option>
        </select>
      </div>
      <div class="form-field" v-show="newUserAgreement.PLOT">
        <label for="owner-select">Собственник:</label>
        <select id="owner-select" v-model="newUserAgreement.USER" ref="user">
          <option v-for="(user, key) in users" :value="user.ID" :key="key">
            {{ user.FIO + " " + user.PHONE }}
          </option>
        </select>
      </div>
      <div class="form-field" v-show="newUserAgreement.USER">
        <label for="agreement-select">
          Тип соглашения:
        </label>
        <select
          id="agreement-select"
          v-model="newUserAgreement.AGREEMENT_TYPE"
          @change="setServices"
          ref="agreementType"
        >
          <option
            v-for="(type, key) in agreementsType"
            :value="type.ID"
            :key="key"
          >
            {{ type.NAME }}
          </option>
        </select>
      </div>
    </div>
    <div class="form-row-line" v-show="newUserAgreement.AGREEMENT_TYPE">
      <div class="form-field">
        <label for="file">Сканы договоров</label>
        <input
          type="file"
          id="file"
          ref="file"
          multiple="multiple"
          v-on:change="handleFileUpload"
        />
      </div>
    </div>
    <div class="form-row-line">
      <div class="form-field">
        <ul>
          <li v-for="(file, key) in fileList" :key="key">- {{ file.name }}</li>
        </ul>
      </div>
    </div>
    <div v-show="newUserAgreement.AGREEMENT_TYPE">
      <div class="form-field">
        <label class="typo__label">Услуги</label>
        <multiselect
          v-model="selectServices"
          :options="services"
          :multiple="true"
          :close-on-select="false"
          :clear-on-select="false"
          :preserve-search="true"
          placeholder="Выберите услуги"
          label="NAME"
          track-by="NAME"
          :preselect-first="true"
        >
          <span slot="noResult">
            Ничего не найдено...
          </span>
        </multiselect>
      </div>
    </div>
    <div class="content">
      <div class="content_title" v-show="accrualrules.length > 0">
        Правила начислений
      </div>
      <div
        class="form-row-line col-4"
        v-for="(rule, key) in accrualrules"
        :key="key"
      >
        <div class="form-field">
          <label :for="'rule-service-' + key">Услуга:</label>
          <div>
            {{ getServiceName(rule.SERVICE) }}
          </div>
        </div>
        <div class="form-field">
          <label :for="'rule-sum-' + key">Сумма:</label>
          <input
            :id="'rule-sum-' + key"
            type="number"
            v-model="accrualrules[key].SUM"
          />
        </div>
        <div class="form-field">
          <label :for="'rule-date-' + key">Дата начислений:</label>
          <input
            :id="'rule-date-' + key"
            type="number"
            v-model="accrualrules[key].DATE"
          />
        </div>
      </div>
    </div>
    <div>
      <div class="form-field">
        <button @click="sendAgreementsData">Добавить</button>
      </div>
    </div>
    <div class="form-row" v-if="info">{{ info }}</div>
  </div>
</template>

<script>
import config from "@/config";

export default {
  name: "addAgreements",
  components: {},
  data() {
    return {
      url: config.backend_url,
      info: null,
      newUserAgreement: {
        USER: null,
        TYPE: "Договор",
        AGREEMENT_TYPE: null,
        PLOT: null,
        SERVICES: [],
        VILLAGE: null
      },
      files: [],
      selectServices: [],
      services: [],
      villages: [],
      plots: [],
      users: [],
      agreementsType: [],
      accrualrules: []
    };
  },
  computed: {
    fileList: function() {
      let result = [];
      Array.prototype.forEach.call(this.files, function(file) {
        result.push(file);
      });
      return result;
    }
  },
  methods: {
    sendDocumentData() {
      let availableServices = [];
      this.selectServices.forEach(function(obj) {
        availableServices.push(parseInt(obj.ID));
      });

      let formData = new FormData();
      Array.prototype.forEach.call(this.files, function(file) {
        formData.append("FILES[]", file);
      });

      formData.append("TYPE", "Договор");
      formData.append("VILLAGE", this.$refs.village.value);
      formData.append("PLOT", this.$refs.plot.value);
      formData.append("USER", this.$refs.user.value);
      formData.append("AGREEMENT_TYPE", this.$refs.agreementType.value);
      formData.append("SERVICES", availableServices);

      let self = this;
      this.$store
        .dispatch("query/sendRequest", {
          url: self.url + "documents/add/",
          method: "POST",
          headers: {
            "Content-Type": "multipart/form-data"
          },
          formData: formData
        })
        .then(response => {
          let data = response.data;
          if (data.agreements) {
            self.info = "Соглашение успешно добавлено";
            self.$emit("agreement-add");
          }
        })
        .catch(error => console.log(error));
    },
    handleFileUpload() {
      this.files = this.$refs.file.files;
    },
    sendAgreementsData: function() {
      this.sendDocumentData();
      this.sendAccrualRulesData();
    },
    sendAccrualRulesData: function() {
      console.log(this.accrualrules);
      let self = this;
      this.$store
        .dispatch("query/sendRequest", {
          url: self.url + "accrualrules/add-multi/",
          data: this.accrualrules,
          method: "POST"
        })
        .then(function(response) {
          let data = response.data;
          if (data.accrualrules) {
            self.info = "Правила успешно добавлены";
            self.$emit("rules-add");
          }
        });
    },
    setServices: function() {
      let self = this;
      let agreementType = this.newUserAgreement.AGREEMENT_TYPE;
      let serv = this.agreementsType[agreementType].SERVICES;
      this.selectServices = this.services.filter(function(service) {
        return serv.includes(service.ID);
      });
      let rules = [];
      this.selectServices.forEach(function(item) {
        rules.push({
          SERVICE: item.ID,
          SUM: null,
          PLOT: self.newUserAgreement.PLOT,
          DATE: null
        });
      });
      this.accrualrules = rules;
    },
    getServiceName: function(serviceId) {
      let data = this.services.filter(function(service) {
        return service.ID === serviceId;
      });
      return data[0].NAME;
    },
    getPlots: function() {
      let self = this;
      this.$store
        .dispatch("query/sendRequest", {
          url: self.url + "plots/get/",
          filter: { VILLAGE: self.newUserAgreement.VILLAGE },
          method: "POST"
        })
        .then(function(response) {
          let data = response.data;
          self.plots = !data.error ? data : [];
        });
    },
    getUsers: function() {
      let self = this;
      this.$store
        .dispatch("query/sendRequest", {
          url: self.url + "users/get/",
          filter: {},
          method: "POST"
        })
        .then(function(response) {
          let data = response.data;
          self.users = !data.error ? data : [];
        });
    },
    getVillages: function() {
      let self = this;
      this.$store
        .dispatch("query/sendRequest", {
          url: self.url + "villages/get/",
          data: {},
          method: "POST"
        })
        .then(function(response) {
          let data = response.data;
          if (!data.error) {
            self.villages = data;
          }
        });
    },
    getServices: function() {
      let self = this;
      this.$store
        .dispatch("query/sendRequest", {
          url: self.url + "services/get/",
          data: {},
          method: "POST"
        })
        .then(function(response) {
          let data = response.data;
          if (!data.error) {
            self.services = Object.values(data);
          }
        });
    },
    getAgreementsType: function() {
      let self = this;
      this.$store
        .dispatch("query/sendRequest", {
          url: self.url + "agreementTypeList/get/",
          data: {},
          method: "POST"
        })
        .then(function(response) {
          let data = response.data;
          if (!data.error) {
            self.agreementsType = data;
          }
        });
    }
  },
  created() {
    this.getAgreementsType();
    this.getVillages();
    this.getUsers();
    this.getServices();
  }
};
</script>
